import blogRequest from './blogRequest'
import moment from "moment";


export const getArticles = (params) => blogRequest().get('/articles', {params: {'published_at_lte': moment().toISOString(), ...params}})
export const getArticle = (id) => blogRequest().get(`/articles/${id}/visualize`)
// export const getCategories = () => blogRequest().get(`/categories`)
